export const JOURNEY_OPTIONS = [
    {value: 'booking_received', text: 'Booking Received'},
    {value: 'empty_container_out', text: 'Empty Container Out'},
    {value: 'loaded_received_from_shipper', text: 'Loaded received from shipper'},
    {value: 'hand_over_for_rail', text: 'Handover for rail'},
    {value: 'rail_out_full', text: 'Rail out full'},
    {value: 'port_gate_in_full', text: 'Port gate in full'},
    {value: 'shipped', text: 'Shipped/On-board'},
    {value: 'discharged', text: 'Discharged'},
    {value: 'booking_cancelled', text: 'Booking Cancelled'},
]
export const JOURNEY_DECORATIONS ={
    'booking_received': {
        color: '#F8B195',
        icon: 'mdi-account-check',
        displayText: 'Booking Received'
    },
    'empty_container_out': {
        color: '#F67280',
        icon: 'hourglass_empty',
        displayText: 'Empty container out: shipper'
    },
    'loaded_received_from_shipper': {
        color: '#C06C84',
        icon: 'mdi-truck-fast',
        displayText: 'Loaded received from shipper'
    },
    'hand_over_for_rail': {
        color: '#6C5B7B',
        icon: 'verified_user',
        displayText: 'Handover for rail/ customs clearance'
    },
    'rail_out_full': {
        color: '#355C7D',
        icon: 'mdi-truck-fast',
        displayText: 'Rail out full'
    },
    'port_gate_in_full': {
        color: '#90A4AE',
        icon: 'mdi-truck-fast',
        displayText: 'Port gated-in full'
    },
    'shipped': {
        color: '#263238',
        icon: 'directions_boat',
        displayText: 'Shipped on-board'
    },
    'discharged': {
        color: '#1B5E20',
        icon: 'place',
        displayText: 'Discharged'
    },
    'booking_cancelled': {
        color: '#1B5E20',
        icon: 'place',
        displayText: 'Booking Cancelled'
    }

}